import React from 'react'
import { Link } from 'react-router-dom'
import chunk from 'lodash/chunk'

import Filters from './Filters'
import { GCP_BUCKET } from './enums'
import postData from './postData'
import styles from './Home.module.css'

export default ({ setFilter, filter }) => {
  const filteredData = postData.filter(post => (filter === 'all' ? true : post.category === filter))
  const chunkedData = chunk(filteredData, 3)
  return (
    <>
      <Filters currFilter={filter} setFilter={setFilter} />
      {chunkedData.map((row, idx) => (
        <div className={styles.row} key={idx}>
          {row.map(post => (
            <div className={styles.col} key={post.slug}>
              <Link to={`/${post.slug}`}>
                <img className={styles.thumbnail} src={`${GCP_BUCKET}${post.thumbnail}`} alt={post.title} />
              </Link>
            </div>
          ))}
        </div>
      ))}
    </>
  )
}
